import React, { Fragment } from 'react';
import { Card, CardBody, Button } from 'reactstrap';
import styled from "styled-components";
const OpitionDiv = styled.div`
margin-left: 20%;
display:flex
.chat-options{
  background-color: red;
padding: 6px;
width: 34%;
border-radius: 10px;
color:white;
margin-right: 8px;
text-align: center;
}
.chat-options:hover{
  cursor: pointer;
}`;

const ChatSuggestiionItems = ({ item, colors }) => {
    const element1 = JSON.parse(item.text);
    return (
        <Fragment>
            <OpitionDiv>
                {element1.map((e) => {
                    return (
                        <div className="chat-options" style={{
                            backgroundColor: colors.suggestionBackground,
                            color: colors.suggestionText,
                            cursor: "pointer"
                        }}>
                            <span>{e.text}</span>
                        </div>
                    );
                })}
            </OpitionDiv>
        </Fragment>
    );
};

export default ChatSuggestiionItems;